var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"station-map"},[_c('virtual-railroad-map',{ref:"virtual-railroad-map",attrs:{"users":_vm.users,"nonprofits":_vm.nonprofits,"zoom":_vm.initialZoom,"icon-size":26,"stations":[_vm.station],"center":{
      lat: 27.620995834987486,
      lng: 2.008774238974298,
    }},on:{"mapReady":_vm.onMapReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }